import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getPeopleCardRouteIdType } from 'mini-people-card-route-store';
import { PeopleCardRouteParams } from 'mini-people-common/lib/schema/PeopleCardRouteParams';

/**
 * Returns route params from email address wrapper required for people card
 * @param emailAddressWrapper
 */
export const getPeopleCardRouteForEmailAddress = (
    emailAddressWrapper: EmailAddressWrapper
): PeopleCardRouteParams => {
    const { EmailAddress, MailboxType, Name } = emailAddressWrapper;

    // For PDL/CL, the email address property is routingType:PersonaID. So PersonaId is extracted and used to load the CL card.
    // routeId - If email address is not there, use the name to create a minimal people card
    const routeId =
        (MailboxType === 'PrivateDL'
            ? EmailAddress?.split(':').reverse().find(Boolean)
            : EmailAddress) || Name;
    const routeIdType = getPeopleCardRouteIdType(MailboxType);

    return {
        routeId,
        routeIdType,
    };
};
